import type { FaireProductEntity } from "../../entity_types/product";

export const p_5t6ctca5kn: FaireProductEntity = {
  token: "p_5t6ctca5kn",
  type: "product",
  name: "Katana Key Chain",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/be67350eb5a2344c3d15c290af36ad1728ead7501c9d32f924cdc446f6f0f36b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c3c55631faacc6fcfd719f0de5afbf6f53131320c441a939f69c5252445b7ac8.jpeg",
    "https://cdn.faire.com/fastly/19d08fbbefb127ba072fcf05417bf9090427709f3afed68bff8de18de8d62a3f.jpeg",
    "https://cdn.faire.com/fastly/c9183870bf73deb4e8cc116b9a96034bfa069d9fc99501d7e703077e64316192.gif"
  ],
  priceDollars: 2,
  description: "Carry a little samurai spirit everywhere with this katana key chain. Shaped like a miniature Japanese sword, it makes a fun add-on for gift shops, anime and martial arts stores, and a souvenir for fans of Japanese culture.\n\nFeatures\n\n * Katana design: a miniature Japanese sword for keys, bags and backpacks \n * Gift-shop favorite: an easy impulse buy for checkout counters \nSpecifications\n\n * Inner pack: 5 \n * Case pack: 300 \n * Origin: China ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:52.868Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
